<template>
  <header
    :class="[
      $style['toolbar'],
      { [$style['toolbar--inline']]: !!inline }
    ]">
    <div
      :class="[$style['toolbar__top'],
               { [$style['toolbar__top--hide-shadow']]: hideShadow }
      ]">
      <slot name="left" />

      <div
        v-if="!hideActions"
        :class="$style['toolbar__actions']">
        <slot name="right" />
      </div>
      <slot />
    </div>
    <div
      v-if="!!$slots['middle']"
      :class="$style['toolbar__middle']">
      <slot name="middle" />
    </div>
    <div
      v-if="!!$slots['bottom']"
      :class="$style['toolbar__bottom']">
      <slot name="bottom" />
    </div>
  </header>
</template>
<script setup>

defineProps({
  inline: {
    type: Boolean,
    default: false
  },
  hideActions: {
    type: Boolean,
    default: false
  },
  hideShadow: {
    type: Boolean,
    default: false
  }
})
</script>
<style lang="scss" module>
.toolbar {
  align-items: center;
  background-color: $white;
  color: $black;
  display: flex;
  flex-direction: column;
  height: calc(var(--toolbar-height) + env(safe-area-inset-top));
  width: 100%;
  position: fixed;
  left: 0;
  z-index: z-index(toolbar);
  transition: .3s;

  :global(.transparent-toolbar) & {
    position: absolute;
  }

  :global(.transparent-toolbar):not(:hover) & {
    background-color: transparent;
  }

  @media (hover: none) and (max-width: #{$breakpoint-tablet - 1}) {
    :global(.transparent-toolbar) & {
      background-color: transparent;
    }
  }

  @media (pointer: coarse) and (max-width: #{$breakpoint-tablet - 1}) {
    :global(.transparent-toolbar) & {
      background-color: transparent;
    }
  }

  &__middle,
  &__top {
    width: 100%;
  }

  &__top {
    background-color: $white;
    color: $black;
    align-items: center;
    justify-content: flex-start;
    display: flex;
    padding: $spacing * 2 $spacing * 3;
    padding-bottom: 0;
    padding-top: max(#{$spacing * 2 }, env(safe-area-inset-top));
    height: calc(env(safe-area-inset-top) + #{$spacing * 8});
    z-index: 1;
    transition: .3s;

    :global(.transparent-toolbar) & {
      background-color: transparent;
    }

    @media (max-width: #{$breakpoint-tablet - 1}) {
      box-shadow: $box-shadow-large;
      padding: 0 $spacing * 2;
      padding-top: env(safe-area-inset-top);
      justify-content: space-between;

      :global(.transparent-toolbar) & {
        box-shadow: none;
      }

    }

    &--hide-shadow {
      box-shadow: none;
    }
  }

  &__middle {
    background-color: $white;
    color: $black;
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    padding: 0 $spacing * 2;
    box-shadow: $box-shadow-large;
    transition: .3s;

    @media (max-width: #{$breakpoint-tablet - 1}) {
      display: none;
    }

    :global(.transparent-toolbar) & {
      background-color: transparent;
      box-shadow: none;
    }
  }

  &__actions button,
  &__actions a {
    transition: .3s;

    :global(.transparent-toolbar) & {
      background-color: transparent;
    }

    :global(.transparent-toolbar):not(:hover) & {
      color: white;
    }

    @media (hover: none) and (max-width: #{$breakpoint-tablet - 1}) {
      :global(.transparent-toolbar) & {
        color: white;
      }
    }

    @media (pointer: coarse) and (max-width: #{$breakpoint-tablet - 1}) {
      :global(.transparent-toolbar) & {
        color: white;
      }
    }
  }

  &__bottom {
    align-items: center;
    justify-content: center;
    display: flex;
    position: absolute;
    width: 100%;
    top: var(--toolbar-height);

    @media (max-width: #{$breakpoint-tablet - 1 }) {
      display: none;
    }
  }

  &--padding {
    padding: 0 $spacing * 2;
  }

  // Used in checkout
  &--inline {
    background-color: transparent;
    min-height: $toolbar-height-mobile;
    height: auto;
    position: relative;

    @media (min-width: #{$breakpoint-tablet}) {
      padding: $spacing * 2 0;
    }

    .toolbar__top {
      background-color: transparent;

      // box-shadow: none;
      border: 0;
      padding: 0 $spacing * 2;
    }

    .toolbar__middle {
      border-bottom: 0;
      justify-content: flex-start;
    }
  }

  &__actions {
    align-items: center;
    display: flex;
    margin-left: auto;
  }
}
</style>
